import { render, staticRenderFns } from "./PrebuiltHeaderWidget.vue?vue&type=template&id=500ca893&scoped=true"
import script from "./PrebuiltHeaderWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrebuiltHeaderWidget.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500ca893",
  null
  
)

export default component.exports